import Backbone from 'backbone'
import _ from 'lodash'
import template from './used-in-list.hbs'
import sections from 'scoreboard/components/sections'
import conductor from 'scoreboard/components/conductor'
import scoreboardUrl from 'scoreboard/components/scoreboard-url'

const UsedInView = Backbone.View.extend({
	className: 'panel used-in',

	initialize: function (options = {}) {
		this.options = options
	},

	render: function () {
		_.forEach(this.options.items, item => {
			item.href = scoreboardUrl(conductor.overviewUrl(sections
				.fromType(item.type), item.id))
		})


		this.$el.html(template({
			items: this.options.items,
			title: this.options.title
		}))
		return this
	}
})

export default UsedInView

UsedInView.__filename__ = 'documents/used-in-list.js'
